import { useState } from 'react';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab6 = ({ customerName,
  setDisable, disable,
  setDelivery, delivery,
  setFrozen, frozen,
  setSalerOrder, salesorder
}) => {
  return (
    <div>
      <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className='mx-2 mb-3' style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          {/* Row 1 */}
          <div style={{ flex: '0 0 48%' }}>
            <input
              type="checkbox"
              id="check1"
              checked={salesorder === 1}
              readOnly
              className='edit-not-allowed'
            />
            <label htmlFor="check1" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
              Allow Sales Invoice Without Sales Order
            </label>
          </div>

          <div style={{ flex: '0 0 48%' }}>
            <input
              type="checkbox"
              id="check2"
              checked={frozen === 1}
              readOnly
              className='edit-not-allowed'
            />
            <label htmlFor="check2" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
              Is Frozen
            </label>
          </div>

          <div style={{ flex: '0 0 48%' }}>
            <input
              type="checkbox"
              id="check3"
              checked={delivery === 1}
              className='edit-not-allowed'
              readOnly
            />
            <label htmlFor="check3" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
              Allow Sales Invoice Without Delivery Note
            </label>
          </div>

          <div style={{ flex: '0 0 48%' }}>
            <input
              type="checkbox"
              id="check4"
              checked={disable === 1}
              className='edit-not-allowed'
              readOnly
            />
            <label htmlFor="check4" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
              Disabled
            </label>
          </div>
        </div>
      </div>
      <div className="">
        <ActivityCard doctype="Customer" docname={customerName} />
      </div>

    </div>
  );
};

export default Tab6;
